// Contract ABIs
export const BASE_IT_NFT_ABI = [
  {
    "type": "constructor",
    "inputs": [
      {"name": "_usdcToken", "type": "address"},
      {"name": "baseTokenURI_", "type": "string"}
    ]
  },
  {
    "type": "function",
    "name": "mint",
    "inputs": [{"name": "tokenURI_", "type": "string"}],
    "outputs": [{"name": "", "type": "uint256"}],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "batchMint",
    "inputs": [{"name": "tokenURIs", "type": "string[]"}],
    "outputs": [{"name": "", "type": "uint256[]"}],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "mintPriceUSDC",
    "inputs": [],
    "outputs": [{"name": "", "type": "uint256"}],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getContractInfo",
    "inputs": [],
    "outputs": [
      {"name": "currentSupply", "type": "uint256"},
      {"name": "maxSupplyValue", "type": "uint256"},
      {"name": "currentMintPriceUSDC", "type": "uint256"},
      {"name": "isMintingEnabled", "type": "bool"},
      {"name": "usdcTokenAddress", "type": "address"}
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "canMint",
    "inputs": [
      {"name": "user", "type": "address"},
      {"name": "amount", "type": "uint256"}
    ],
    "outputs": [{"name": "", "type": "bool"}],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "totalSupply",
    "inputs": [],
    "outputs": [{"name": "", "type": "uint256"}],
    "stateMutability": "view"
  },
  {
    "type": "event",
    "name": "NFTMinted",
    "inputs": [
      {"name": "owner", "type": "address", "indexed": true},
      {"name": "tokenId", "type": "uint256", "indexed": true},
      {"name": "tokenURI", "type": "string", "indexed": false},
      {"name": "pricePaid", "type": "uint256", "indexed": false}
    ]
  }
]

export const USDC_ABI = [
  {
    "type": "function",
    "name": "balanceOf",
    "inputs": [{"name": "owner", "type": "address"}],
    "outputs": [{"name": "", "type": "uint256"}],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "allowance",
    "inputs": [
      {"name": "owner", "type": "address"},
      {"name": "spender", "type": "address"}
    ],
    "outputs": [{"name": "", "type": "uint256"}],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "approve",
    "inputs": [
      {"name": "spender", "type": "address"},
      {"name": "amount", "type": "uint256"}
    ],
    "outputs": [{"name": "", "type": "bool"}],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "decimals",
    "inputs": [],
    "outputs": [{"name": "", "type": "uint8"}],
    "stateMutability": "view"
  }
]
